import { PanelTicketRoute } from '@/modules/ticket/routes/panel-ticket.route'
import { PanelType } from '@/modules/shared/interfaces/panel-type'

export class WriterTicketRoute extends PanelTicketRoute {
  panelType = PanelType.WRITER
}
